import React, { useContext, useState } from 'react';
import { LanguageContextData } from './types';
import { textValues, LanguageContext } from './utils';

interface TokenFormProps {
    setToken: (token: string) => void,
};

const TokenForm = ({ setToken }: TokenFormProps) => {
  const { language } = useContext<LanguageContextData>(LanguageContext);
  const [ tokenValue, setTokenValue ] = useState<string>('');

  return (
    <article>
      <h1>{ textValues[language]['token'] }</h1>
      <p>{ textValues[language]['tokenText'] }</p>
      <span className='right'>
        <a href='https://www.buymeacoffee.com/hagenschupp' target='_blank' rel='noreferrer'>
          <img className='coffee' src='https://cdn.buymeacoffee.com/buttons/v2/arial-blue.png' alt='Buy Me A Coffee' />
        </a>
      </span>
      <form>
        <div className='row'>
          <label htmlFor='token'>Token:</label>
          <input type='text' id='token' value={ tokenValue } onChange={ (e) => setTokenValue(e.target.value) }/>
        </div>
        <div className='row'>
          &nbsp;
          <button disabled={ tokenValue.length === 0 } onClick={ (e) => { e.preventDefault(); setToken(tokenValue) } }>{ textValues[language]['tokenButton'] }</button> 
        </div>
      </form>
    </article>
  );
};
export default TokenForm;